import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutline';

// Ícone "i" minimizado — hover/tap pra ver a explicação da tela, sem ocupar
// espaço permanente como um parágrafo fixo.
const ScreenDescription = ({ children }) => (
  <div style={{ margin: '4px 0 12px' }}>
    <Tooltip title={<span style={{ fontSize: 13, lineHeight: 1.5 }}>{children}</span>} placement="bottom-start" interactive>
      <IconButton size="small" style={{ padding: 4 }}>
        <InfoOutlinedIcon fontSize="small" style={{ color: '#8a93a3' }} />
      </IconButton>
    </Tooltip>
  </div>
);

export default ScreenDescription;
